<template>
  <v-col cols="12" sm="12" md="3" class="filter-sidebar">
    <div :style="sidebarPadding">
      <div class="sidebar-header">
        <h2>Calendar</h2>
        <p class="subtitle">{{ getCurrentDate }}</p>
      </div>

      <FilterSection
        :filters="filters"
        :has-active-filters="hasActiveFilters"
        @reset-filters="$emit('reset-filters')"
        @option-selected="handleFilterOptionSelected"
        @get-option-count="handleGetOptionCount"
      />

      <UpcomingEvents
        v-if="$vuetify.breakpoint.mdAndUp"
        :upcoming-events="upcomingEvents"
        @view-all="$emit('view-all-events')"
      />
    </div>
  </v-col>
</template>

<script>
import FilterSection from "./FilterSection.vue";
import UpcomingEvents from "./UpcomingEvents.vue";

export default {
  name: "CalendarSidebar",

  components: {
    FilterSection,
    UpcomingEvents,
  },

  props: {
    filters: {
      type: Array,
      required: true,
      default: () => [],
    },
    upcomingEvents: {
      type: Array,
      required: true,
      default: () => [],
    },
    hasActiveFilters: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sidebarPadding() {
      const { xs, sm, md } = this.$vuetify.breakpoint;
      if (xs) return { padding: "2px" };
      if (sm) return { padding: "8px" };
      if (md) return { padding: "24px" };
      return { padding: "32px" };
    },
    getCurrentDate() {
      return new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },

  methods: {
    handleFilterOptionSelected(payload) {
      this.$emit("filter-changed", payload);
    },

    handleGetOptionCount(option) {
      this.$emit("get-option-count", option);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-sidebar {
  background: white;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  height: 100vh;
  overflow-y: auto;
}

.sidebar-content {
  padding: 24px;
}

.sidebar-header {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 32px;

  h2 {
    color: white;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .subtitle {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
  }

  .today-quick-btn {
    color: white;
    margin-top: 12px;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
